import { useQuery } from "@tanstack/react-query"

import { getSBCredentials, getUserSMSStatus, loadUser } from "./api"
import useCurrentClient from "../../pages/clients/hooks/useCurrentClient"
import { QueryKey } from "../../types/queries"
import { sessionManager } from "../../util/storage"

export const useUserQuery = () => {
  const hasRefreshToken = sessionManager.getRefreshToken()

  return useQuery({
    queryKey: [QueryKey.USER],
    queryFn: loadUser,
    enabled: !!hasRefreshToken,
    onError: sessionManager.clearAuthTokens,
  })
}

export const useSBCredentialsQuery = () => {
  const { data: user } = useUserQuery()
  return useQuery({
    queryKey: [QueryKey.SB_CREDENTIALS],
    queryFn: () => getSBCredentials(user?.id!),
    enabled: !!user?.id,
  })
}

export const useUserSMSStatusQuery = () => {
  const { currentClientProfile } = useCurrentClient()
  return useQuery({
    queryKey: [QueryKey.USER_SMS_STATUS, currentClientProfile?.user.id],
    queryFn: () => getUserSMSStatus(currentClientProfile?.user.id!),
    enabled: !!currentClientProfile?.user.id,
  })
}
